/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _site_menu__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _site_sliders__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
/* harmony import */ var _site_scrollTo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4);
/* harmony import */ var _site_styleguide__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
/* harmony import */ var _site_fancybox__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6);
/* harmony import */ var _site_select2__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7);
/* harmony import */ var _site_formHelpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8);
/* harmony import */ var _site_perfectScroll__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9);
/* harmony import */ var _site_equalHeights__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11);
/* harmony import */ var _site_menuMain__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(12);
/* harmony import */ var _site_changelayout__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(13);
/* harmony import */ var _site_servicesheight__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(14);
/* harmony import */ var _site_stickyScroll__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(15);
/* harmony import */ var _site_megamenu__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(16);
/* harmony import */ var _site_loadMorePosts__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(17);
/* harmony import */ var _site_toggle__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(18);
















jQuery(function () {
  _site_styleguide__WEBPACK_IMPORTED_MODULE_3__["default"].init();
  _site_menu__WEBPACK_IMPORTED_MODULE_0__["default"].init();
  _site_sliders__WEBPACK_IMPORTED_MODULE_1__["default"].init();
  _site_scrollTo__WEBPACK_IMPORTED_MODULE_2__["default"].init();
  _site_fancybox__WEBPACK_IMPORTED_MODULE_4__["default"].init();
  _site_select2__WEBPACK_IMPORTED_MODULE_5__["default"].init();
  _site_formHelpers__WEBPACK_IMPORTED_MODULE_6__["default"].init();
  _site_perfectScroll__WEBPACK_IMPORTED_MODULE_7__["default"].init();
  _site_equalHeights__WEBPACK_IMPORTED_MODULE_8__["default"].init();
  _site_menuMain__WEBPACK_IMPORTED_MODULE_9__["default"].init();
  _site_changelayout__WEBPACK_IMPORTED_MODULE_10__["default"].init();
  _site_servicesheight__WEBPACK_IMPORTED_MODULE_11__["default"].init();
  _site_stickyScroll__WEBPACK_IMPORTED_MODULE_12__["default"].init();
  _site_megamenu__WEBPACK_IMPORTED_MODULE_13__["default"].init();
  _site_loadMorePosts__WEBPACK_IMPORTED_MODULE_14__["default"].init();
  _site_toggle__WEBPACK_IMPORTED_MODULE_15__["default"].init();
});

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
var $ = jQuery.noConflict();

'use strict';

var Menu = {
  /**
   * @description Cache dom and strings
   * @type {object}
   */
  $domMenuBtn: $('.js-menu-btn'),
  $domMenuOuter: $('.js-nav-outer'),
  $domMenuInner: $('.js-nav-inner'),
  $domMenuIcon: $('.js-nav-icon'),
  $domMenuSub: $('.sub-menu'),
  $domHeader: $('.site-header'),
  slMenuIcon: '.js-nav-icon',
  slMenuSub: '.sub-menu',
  classActive: 'is-active',
  timeout: null,

  /** @description Initialize */
  init: function init() {
    this.bindEvents();
  },

  /** @description Bind Events */
  bindEvents: function bindEvents() {
    this.$domMenuBtn.on('click', this.toggleMenu.bind(this));
    this.$domMenuIcon.on('click', this.toggleSubMenu.bind(this));
    _global__WEBPACK_IMPORTED_MODULE_0__["default"].escKey(this.closeMenu.bind(this));
    _global__WEBPACK_IMPORTED_MODULE_0__["default"].clickOutsideContainer(_global__WEBPACK_IMPORTED_MODULE_0__["default"].$domBody, this.$domMenuInner, this.$domMenuBtn, this.closeMenu.bind(this));
  },
  toggleMenu: function toggleMenu() {
    if (!this.$domMenuBtn.hasClass(this.classActive)) {
      this.$domMenuBtn.addClass(this.classActive);
      this.$domMenuOuter.addClass(this.classActive);
      $('body').addClass('overflow');
    } else {
      this.closeMenu();
    }
  },
  toggleSubMenu: function toggleSubMenu(e) {
    var icon = $(e.target.closest(this.slMenuIcon));
    var ul = icon.siblings(this.slMenuSub);

    if (!icon.hasClass(this.classActive)) {
      icon.addClass(this.classActive);
      $('body').addClass('overflow');
      ul.slideDown();
    } else {
      icon.removeClass(this.classActive);
      icon.parent().find(this.slMenuIcon).removeClass(this.classActive);
      ul.slideUp();
      ul.find(this.slMenuSub).slideUp();
    }
  },
  closeMenu: function closeMenu() {
    var _this = this;

    this.$domMenuBtn.removeClass(this.classActive);
    this.$domMenuOuter.removeClass(this.classActive);
    $('body').removeClass('overflow'); // timeout should match the selectors CSS transition duration property

    clearTimeout(this.timeout);
    this.timeout = setTimeout(function () {
      _this.$domMenuIcon.removeClass(_this.classActive);

      _this.$domMenuSub.slideUp();
    }, 300);
  }
};
$(document).on('scroll', function () {
  var scrollTop = $(document).scrollTop();

  if (scrollTop > 10) {
    Menu.$domHeader.addClass('scroll');
    $('.megamenu').addClass('scroll');
  } else {
    Menu.$domHeader.removeClass('scroll');
    $('.megamenu').removeClass('scroll');
  }
});
$('.js-search').click(function () {
  $('.search-toggle').toggleClass('search-active');
});
/* harmony default export */ __webpack_exports__["default"] = (Menu);

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var $ = jQuery.noConflict();
'use strict';

var Global = {
  /**
   * @description Cache dom and strings
   * @type {object}
   */
  $domWindow: $(window),
  $domDoc: $(document),
  $domBody: $('body'),
  varsWindowWidth: window.innerWidth,

  /**
   * @description do something on escape key click
   * @example Global.functions.escKey(closeNav);
   * @param {function} callback - pass callback function
   */
  escKey: function escKey(callback) {
    Global.$domDoc.on('keyup', function (e) {
      if (e.keyCode === 27) {
        callback();
      }
    });
  },

  /**
   * @description Click outside container to close it (e.g. popups, menu...)
   * @example Global.functions.clickOutsideContainer(this.$domMenuNav, this.$domMenuNav.children('ul'), this.$domMenuBtn, closeNav);
   * @param {jQuery} selector - element that trigger function ( e.g. $('body') );
   * @param {jQuery} container - popup wrapper
   * @param {jQuery} closeBtn - close button
   * @param {function} callback - callback function
   */
  clickOutsideContainer: function clickOutsideContainer(selector, container, closeBtn, callback) {
    selector.on('mouseup', function (e) {
      e.preventDefault();

      if (!container.is(e.target) && container.has(e.target).length === 0 && !closeBtn.is(e.target)) {
        callback();
      }
    });
  },

  /**
   * @description Equal height function for multiple elements. This function should be used on load and on resize also.
   * @example Global.functions.equalHeights('.some-element-class');
   * @example $(window).on('resize', ()=> { Global.functions.equalHeights('.some-element-class'); });
   * @param {jQuery} elm - element class
   */
  equalHeights: function equalHeights(elm) {
    var x = 0;
    elm.height('auto');
    elm.each(function (index, el) {
      if ($(el).height() > x) {
        x = $(el).height();
      }
    });
    elm.height(x + 1);
  },
  scrollTo: function scrollTo(selector) {
    $(selector).on('click', function (e) {
      e.preventDefault();
      var target = $(e.currentTarget.hash);
      console.log(target);

      if (target.length) {
        $('html,body').animate({
          scrollTop: target.offset().top
        }, 1000);
        return false;
      }
    });
  }
};
/* harmony default export */ __webpack_exports__["default"] = (Global);

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var $ = jQuery.noConflict();
'use strict';

var Sliders = {
  /**
   * @description Cache dom and strings
   * @type {object}
   */
  $domSlider: $('.js-slider'),
  $bannerSlider: $('.js-banner-slider'),
  $mainSlider: $('.js-main-slider'),
  classMainSlider: $('.js-main-slider'),
  slCustomMainWrap: '.main-slider',
  $testimonialsSlider: $('.js-testimonials-slider'),
  $simpleSlider: $('.js-simple-slider'),
  $newsSlider: $('.ja-news-slider'),

  /** @description Initialize */
  init: function init() {
    this.sliderExample();
    this.mainSlider();
    this.bannerSlider();
    this.testimonialsSlider();
    this.simpleSlider();
    this.newsSlider();
  },

  /** @description slider example description e.g Banner slider */
  sliderExample: function sliderExample() {
    Sliders.$domSlider.slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      speed: 1000,
      arrows: false,
      responsive: [{
        breakpoint: 991,
        settings: {
          slidesToShow: 3
        }
      }, {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      }]
    });
  },
  bannerSlider: function bannerSlider() {
    Sliders.$bannerSlider.slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      speed: 1000,
      arrows: true,
      fade: true,
      prevArrow: $('.icon-arrow-prev'),
      nextArrow: $('.icon-arrow-next')
    });
  },
  simpleSlider: function simpleSlider() {
    Sliders.$simpleSlider.slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      speed: 1000,
      arrows: true,
      prevArrow: $('.simple-arrow-prev'),
      nextArrow: $('.simple-arrow-next'),
      responsive: [{
        breakpoint: 991,
        settings: {
          slidesToShow: 2
        }
      }, {
        breakpoint: 640,
        settings: {
          slidesToShow: 1
        }
      }]
    });
  },
  newsSlider: function newsSlider() {
    Sliders.$newsSlider.slick({
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      // autoplay: true,
      speed: 1000,
      arrows: true,
      prevArrow: $('.news-arrow-prev'),
      nextArrow: $('.news-arrow-next'),
      responsive: [{
        breakpoint: 991,
        settings: {
          slidesToShow: 2
        }
      }, {
        breakpoint: 640,
        settings: {
          slidesToShow: 1
        }
      }]
    });
  },
  testimonialsSlider: function testimonialsSlider() {
    Sliders.$testimonialsSlider.slick({
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: true,
      speed: 1000,
      arrows: false,
      asNavFor: '.js-testimonials-slider-nav',
      responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 2
        }
      }, {
        breakpoint: 991,
        settings: {
          slidesToShow: 1
        }
      }, {
        breakpoint: 640,
        settings: {
          infinite: false,
          slidesToShow: 1
        }
      }]
    });
    $('.js-testimonials-slider-nav').slick({
      // slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.js-testimonials-slider',
      dots: true,
      arrows: false,
      focusOnSelect: true
    });
  },
  mainSlider: function mainSlider() {
    Sliders.classMainSlider.each(function (i, el) {
      $(el).slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 600,
        fade: true,
        dots: false,
        autoplay: true,
        arrows: false,
        pauseOnHover: false,
        asNavFor: '.main-slider-nav'
      });
      $('.main-slider-nav').slick({
        slidesToShow: 15,
        slidesToScroll: 3,
        speed: 600,
        centerMode: true,
        asNavFor: '.js-main-slider',
        variableWidth: true,
        dots: false,
        autoplay: true,
        arrows: false,
        pauseOnHover: false,
        focusOnSelect: true
      });
    });
  }
};
/* harmony default export */ __webpack_exports__["default"] = (Sliders);

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var $ = jQuery.noConflict();
'use strict';
/**
 * @description In order to create link that scrolls to certain section, simply place '#scroll-section-example' to a desired tag and id with same value to the section page should scroll to.
 * @description Alternately, you can enable any URL with# to autoscroll on page load. For example: some - website.com / #scroll - section - example
 * @example tag: <a class="btn" href="#scroll-section-example"> will scroll to: <div class="some-section" id="scroll-section-example">
 */


var ScrollTo = {
  /**
   * @description Cache dom and strings
   * @type {object}
   */
  $domScrollLink: $('a[href*=\\#]:not([href=\\#]):not(".footer-list-v2 a")'),
  // $filterList: $('.filter-list li a'),
  $servicesBlock: $('.services-block .section-title'),

  /** @description Initialize */
  init: function init() {
    this.bindEvents();
    this.hashScroll();
  },
  bindEvents: function bindEvents() {
    var _this = this;

    _this.$domScrollLink.on('click', function (e) {
      e.preventDefault();
      var target = $(e.currentTarget.hash);
      console.log(target);

      _this.scrollToTarget(target);
    });
  },
  hashScroll: function hashScroll() {
    var _this2 = this;

    var hash = window.location.hash;

    if (hash) {
      var target = $(hash);
      setTimeout(function () {
        _this2.scrollToTarget(target, 100, 500);
      }, 250);
    }
  },
  scrollToTarget: function scrollToTarget(target) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
    var scrollSpeed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1200;

    if (target.length) {
      $('html,body').animate({
        scrollTop: target.offset().top - offset
      }, scrollSpeed);
    }
  }
};
/* harmony default export */ __webpack_exports__["default"] = (ScrollTo);

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
var $ = jQuery.noConflict();

'use strict';

var Styleguide = {
  /**
   * @description Cache dom and strings
   * @type {object}
   */
  $domStyleNavWrap: $('.js-styleguide-nav-wrap'),
  $domStyleNav: $('.js-styleguide-nav'),
  $domStyleSection: $('.js-styleguide-section'),
  $domStyleNavClose: $('.js-styleguide-close'),
  $domStyleNavOpen: $('.js-styleguide-open'),
  $domStyleNavInput: $('.js-styleguide-filter-input'),
  selectorStyleNav: '.js-styleguide-nav',
  selectorStyleNavItem: '.styleguide__scrollspy-nav-list .list-group-item',
  selectorStyleNavLink: '.list-group-item',
  classHidden: 'is-hidden',
  classActive: 'active',
  attrSectionTitle: 'data-section-title',

  /** @description slider example description e.g Banner slider */
  init: function init() {
    Styleguide.styleguideList();
    Styleguide.openStyleguideSidebar();
    Styleguide.filterComponents();
    Styleguide.listItemClick();
  },
  styleguideList: function styleguideList() {
    if (Styleguide.$domStyleNav.length) {
      Styleguide.$domStyleSection.each(function (i, el) {
        Styleguide.$domStyleNav.append(Styleguide.getHtmlListItem(el, i));
        $(Styleguide.selectorStyleNavLink).first().addClass(Styleguide.classActive);
        Styleguide.$domStyleSection.first().addClass(Styleguide.classActive);
        _global__WEBPACK_IMPORTED_MODULE_0__["default"].$domBody.scrollspy({
          target: Styleguide.selectorStyleNav
        });
      });
    }

    _global__WEBPACK_IMPORTED_MODULE_0__["default"].scrollTo('.list-group-item');
  },

  /**
   * @description close/open Styleguide Nav
   */
  openStyleguideSidebar: function openStyleguideSidebar() {
    Styleguide.$domStyleNavOpen.on('click', function () {
      Styleguide.$domStyleNavWrap.toggleClass(Styleguide.classHidden);
    });
  },

  /**
   * @description filter sidebar components
   */
  filterComponents: function filterComponents() {
    Styleguide.$domStyleNavInput.on('keyup', function (e) {
      var _self = $(e.currentTarget);

      var value = _self.val().toLowerCase();

      $(Styleguide.selectorStyleNavItem).filter(function () {
        var __self = $(this);

        __self.toggle(__self.text().toLowerCase().indexOf(value) > -1);
      });
    });
  },
  listItemClick: function listItemClick() {
    $(Styleguide.selectorStyleNavLink).on('click', function (e) {
      var _self = $(e.currentTarget);

      _self.addClass(Styleguide.classActive).parent().siblings().find('a').removeClass(Styleguide.classActive);
    });
  },
  getHtmlListItem: function getHtmlListItem(el, i) {
    var svgIcon = this.getHtmlSvg();
    return "\n\t\t\t<li>\n\t\t\t\t<a class=\"list-group-item\" href=\"#section-".concat(i, "\">").concat(svgIcon).concat($(el).attr(this.attrSectionTitle), "</a>\n\t\t\t</li>\n\t\t");
  },
  getHtmlSvg: function getHtmlSvg() {
    return '<span class="list-group-item__icon svg-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" fill="currentColor"><path d="M336 0H48C21.49 0 0 21.49 0 48v464l192-112 192 112V48c0-26.51-21.49-48-48-48zm16 456.287l-160-93.333-160 93.333V48c0-8.822 7.178-16 16-16h288c8.822 0 16 7.178 16 16v408.287z"></path></svg></span>';
  }
};
/* harmony default export */ __webpack_exports__["default"] = (Styleguide);

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var $ = jQuery.noConflict();
'use strict';

var Fancybox = {
  /**
   * @description Cache dom and strings
   * @type {object}
   */

  /** @description Initialize */
  init: function init() {
    this.fancyboxPopup('.js-video-trigger', '.js-video-popup');
  },

  /**
   * @description Fancy box custom popup functionality.
   * @link documentation https://fancyapps.com/fancybox/3/docs/#inline
   * @example this.functions.fancyboxPopup('.popup-btn', '.popup', 'my-custom-class');
   * @param {string} trigger - popup trigger
   * @param {string} popup - popup wrapper class
   * @param {string} customClass - custom class for each popup (optional)
   */
  fancyboxPopup: function fancyboxPopup(trigger, popup) {
    var customClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    $(trigger).fancybox({
      src: popup,
      type: 'inline',
      smallBtn: true,
      baseClass: customClass
    });
  }
};
/* harmony default export */ __webpack_exports__["default"] = (Fancybox);

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var $ = jQuery.noConflict();
'use strict';

var Select2 = {
  /**
   * @description Cache dom and strings
   * @type {object}
   */
  $select: $('.js-select'),

  /** @description Initialize */
  init: function init() {
    this.select2();
  },
  select2: function select2() {
    /**
     * @description Select2 global function
     * @link Documentation https://select2.org/
     * @type {object}
     */
    Select2.$select.select2({
      minimumResultsForSearch: -1,
      width: 'style',
      dropdownCssClass: 'custom-class',
      placeholder: 'Select One'
    });
  }
};
$('body').on('click', function () {
  if ($('.select2-container').hasClass('select2-container--open')) {
    $('.select-holder').addClass('open');
  } else {
    $('.select-holder').removeClass('open');
  }
});
$('.js-select').on('select2:selecting', function () {
  $('.select-holder').removeClass('open');
});
/* harmony default export */ __webpack_exports__["default"] = (Select2);

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var $ = jQuery.noConflict();
'use strict';

var FormHelpers = {
  /**
   * @description Cache dom and strings
   * @type {object}
   */

  /** @description Initialize */
  init: function init() {
    this.afterFormSubmit();
  },

  /**
   * @description CF7 after submit popup trigger. Structure-example ( https://www.dropbox.com/s/oyj5revbgwigzxr/download.jpg?dl=0 )
   * @example Global.functions.afterFormSubmit('.js-cf7-holder', 'form-is-sent', 8000);
   * @param {string} formHolder - form holder class (recommended/default is '.js-cf7-holder')
   * @param {string} sentClass - class added to form parent to trigger popup (default is 'form-is-sent')
   * @param {number} delay - delay time before sentClass is removed (default delay time is 5000ms)
   */
  afterFormSubmit: function afterFormSubmit() {
    var formHolder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.js-cf7-holder';
    var sentClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'form-is-sent';
    var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5000;
    document.addEventListener('wpcf7mailsent', function (e) {
      var formId = e.detail.id;
      $("#".concat(formId)).parents(formHolder).addClass(sentClass);
      setTimeout(function () {
        $(formHolder).removeClass(sentClass);
      }, delay);
    }, false);
  }
}; // $('.banner-play').click(function() {
// 	if($(this).attr('data-click') === 1) {
// 		$(this).attr('data-click', 0);
// 		$(this).text('Play');
// 		$('.banner__video')[0].pause();
// 		console.log('if');
// 	} else {
// 		$(this).attr('data-click', 1);
// 		$(this).text('');
// 		$('.banner__video')[0].play();
// 		console.log('else');
// 	}
// });

/* harmony default export */ __webpack_exports__["default"] = (FormHelpers);

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _plugins_perfect_scrollbar__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10);
/* harmony import */ var _plugins_perfect_scrollbar__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_plugins_perfect_scrollbar__WEBPACK_IMPORTED_MODULE_0__);
var $ = jQuery.noConflict();

'use strict';

var PSB = {
  /**
   * @description Cache dom and strings
   * @type {object}
   */
  selectorStyleguideNav: '.js-styleguide-nav-list-holder',
  classHide: 'hideFade',

  /** @description Initialize */
  init: function init() {
    PSB.perfectScrollBarStyleguide();
  },

  /**
   * @description Stylequide scrollbar
   */
  perfectScrollBarStyleguide: function perfectScrollBarStyleguide() {
    $(PSB.selectorStyleguideNav).each(function (i, el) {
      var selector = $(el)[0];
      var ps = new _plugins_perfect_scrollbar__WEBPACK_IMPORTED_MODULE_0___default.a(selector, {
        wheelSpeed: 1,
        suppressScrollX: true,
        minScrollbarLength: 100
      });
      selector.addEventListener('ps-scroll-y', function (e) {
        var _self = $(e.currentTarget);

        var reach = ps.reach.y;
        reach === 'end' ? _self.parent().addClass(PSB.classHide) : _self.parent().removeClass(PSB.classHide);
      });
    });
  }
};
/* harmony default export */ __webpack_exports__["default"] = (PSB);

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*!
 * perfect-scrollbar v1.5.0
 * Copyright 2020 Hyunje Jun, MDBootstrap and Contributors
 * Licensed under MIT
 */
(function (global, factory) {
  ( false ? undefined : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : (undefined);
})(this, function () {
  'use strict';

  function get(element) {
    return getComputedStyle(element);
  }

  function set(element, obj) {
    for (var key in obj) {
      var val = obj[key];

      if (typeof val === 'number') {
        val = val + "px";
      }

      element.style[key] = val;
    }

    return element;
  }

  function div(className) {
    var div = document.createElement('div');
    div.className = className;
    return div;
  }

  var elMatches = typeof Element !== 'undefined' && (Element.prototype.matches || Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector);

  function matches(element, query) {
    if (!elMatches) {
      throw new Error('No element matching method supported');
    }

    return elMatches.call(element, query);
  }

  function remove(element) {
    if (element.remove) {
      element.remove();
    } else {
      if (element.parentNode) {
        element.parentNode.removeChild(element);
      }
    }
  }

  function queryChildren(element, selector) {
    return Array.prototype.filter.call(element.children, function (child) {
      return matches(child, selector);
    });
  }

  var cls = {
    main: 'ps',
    rtl: 'ps__rtl',
    element: {
      thumb: function thumb(x) {
        return "ps__thumb-" + x;
      },
      rail: function rail(x) {
        return "ps__rail-" + x;
      },
      consuming: 'ps__child--consume'
    },
    state: {
      focus: 'ps--focus',
      clicking: 'ps--clicking',
      active: function active(x) {
        return "ps--active-" + x;
      },
      scrolling: function scrolling(x) {
        return "ps--scrolling-" + x;
      }
    }
  };
  /*
   * Helper methods
   */

  var scrollingClassTimeout = {
    x: null,
    y: null
  };

  function addScrollingClass(i, x) {
    var classList = i.element.classList;
    var className = cls.state.scrolling(x);

    if (classList.contains(className)) {
      clearTimeout(scrollingClassTimeout[x]);
    } else {
      classList.add(className);
    }
  }

  function removeScrollingClass(i, x) {
    scrollingClassTimeout[x] = setTimeout(function () {
      return i.isAlive && i.element.classList.remove(cls.state.scrolling(x));
    }, i.settings.scrollingThreshold);
  }

  function setScrollingClassInstantly(i, x) {
    addScrollingClass(i, x);
    removeScrollingClass(i, x);
  }

  var EventElement = function EventElement(element) {
    this.element = element;
    this.handlers = {};
  };

  var prototypeAccessors = {
    isEmpty: {
      configurable: true
    }
  };

  EventElement.prototype.bind = function bind(eventName, handler) {
    if (typeof this.handlers[eventName] === 'undefined') {
      this.handlers[eventName] = [];
    }

    this.handlers[eventName].push(handler);
    this.element.addEventListener(eventName, handler, false);
  };

  EventElement.prototype.unbind = function unbind(eventName, target) {
    var this$1 = this;
    this.handlers[eventName] = this.handlers[eventName].filter(function (handler) {
      if (target && handler !== target) {
        return true;
      }

      this$1.element.removeEventListener(eventName, handler, false);
      return false;
    });
  };

  EventElement.prototype.unbindAll = function unbindAll() {
    for (var name in this.handlers) {
      this.unbind(name);
    }
  };

  prototypeAccessors.isEmpty.get = function () {
    var this$1 = this;
    return Object.keys(this.handlers).every(function (key) {
      return this$1.handlers[key].length === 0;
    });
  };

  Object.defineProperties(EventElement.prototype, prototypeAccessors);

  var EventManager = function EventManager() {
    this.eventElements = [];
  };

  EventManager.prototype.eventElement = function eventElement(element) {
    var ee = this.eventElements.filter(function (ee) {
      return ee.element === element;
    })[0];

    if (!ee) {
      ee = new EventElement(element);
      this.eventElements.push(ee);
    }

    return ee;
  };

  EventManager.prototype.bind = function bind(element, eventName, handler) {
    this.eventElement(element).bind(eventName, handler);
  };

  EventManager.prototype.unbind = function unbind(element, eventName, handler) {
    var ee = this.eventElement(element);
    ee.unbind(eventName, handler);

    if (ee.isEmpty) {
      // remove
      this.eventElements.splice(this.eventElements.indexOf(ee), 1);
    }
  };

  EventManager.prototype.unbindAll = function unbindAll() {
    this.eventElements.forEach(function (e) {
      return e.unbindAll();
    });
    this.eventElements = [];
  };

  EventManager.prototype.once = function once(element, eventName, handler) {
    var ee = this.eventElement(element);

    var onceHandler = function onceHandler(evt) {
      ee.unbind(eventName, onceHandler);
      handler(evt);
    };

    ee.bind(eventName, onceHandler);
  };

  function createEvent(name) {
    if (typeof window.CustomEvent === 'function') {
      return new CustomEvent(name);
    } else {
      var evt = document.createEvent('CustomEvent');
      evt.initCustomEvent(name, false, false, undefined);
      return evt;
    }
  }

  function processScrollDiff(i, axis, diff, useScrollingClass, forceFireReachEvent) {
    if (useScrollingClass === void 0) useScrollingClass = true;
    if (forceFireReachEvent === void 0) forceFireReachEvent = false;
    var fields;

    if (axis === 'top') {
      fields = ['contentHeight', 'containerHeight', 'scrollTop', 'y', 'up', 'down'];
    } else if (axis === 'left') {
      fields = ['contentWidth', 'containerWidth', 'scrollLeft', 'x', 'left', 'right'];
    } else {
      throw new Error('A proper axis should be provided');
    }

    processScrollDiff$1(i, diff, fields, useScrollingClass, forceFireReachEvent);
  }

  function processScrollDiff$1(i, diff, ref, useScrollingClass, forceFireReachEvent) {
    var contentHeight = ref[0];
    var containerHeight = ref[1];
    var scrollTop = ref[2];
    var y = ref[3];
    var up = ref[4];
    var down = ref[5];
    if (useScrollingClass === void 0) useScrollingClass = true;
    if (forceFireReachEvent === void 0) forceFireReachEvent = false;
    var element = i.element; // reset reach

    i.reach[y] = null; // 1 for subpixel rounding

    if (element[scrollTop] < 1) {
      i.reach[y] = 'start';
    } // 1 for subpixel rounding


    if (element[scrollTop] > i[contentHeight] - i[containerHeight] - 1) {
      i.reach[y] = 'end';
    }

    if (diff) {
      element.dispatchEvent(createEvent("ps-scroll-" + y));

      if (diff < 0) {
        element.dispatchEvent(createEvent("ps-scroll-" + up));
      } else if (diff > 0) {
        element.dispatchEvent(createEvent("ps-scroll-" + down));
      }

      if (useScrollingClass) {
        setScrollingClassInstantly(i, y);
      }
    }

    if (i.reach[y] && (diff || forceFireReachEvent)) {
      element.dispatchEvent(createEvent("ps-" + y + "-reach-" + i.reach[y]));
    }
  }

  function toInt(x) {
    return parseInt(x, 10) || 0;
  }

  function isEditable(el) {
    return matches(el, 'input,[contenteditable]') || matches(el, 'select,[contenteditable]') || matches(el, 'textarea,[contenteditable]') || matches(el, 'button,[contenteditable]');
  }

  function outerWidth(element) {
    var styles = get(element);
    return toInt(styles.width) + toInt(styles.paddingLeft) + toInt(styles.paddingRight) + toInt(styles.borderLeftWidth) + toInt(styles.borderRightWidth);
  }

  var env = {
    isWebKit: typeof document !== 'undefined' && 'WebkitAppearance' in document.documentElement.style,
    supportsTouch: typeof window !== 'undefined' && ('ontouchstart' in window || 'maxTouchPoints' in window.navigator && window.navigator.maxTouchPoints > 0 || window.DocumentTouch && document instanceof window.DocumentTouch),
    supportsIePointer: typeof navigator !== 'undefined' && navigator.msMaxTouchPoints,
    isChrome: typeof navigator !== 'undefined' && /Chrome/i.test(navigator && navigator.userAgent)
  };

  function updateGeometry(i) {
    var element = i.element;
    var roundedScrollTop = Math.floor(element.scrollTop);
    var rect = element.getBoundingClientRect();
    i.containerWidth = Math.ceil(rect.width);
    i.containerHeight = Math.ceil(rect.height);
    i.contentWidth = element.scrollWidth;
    i.contentHeight = element.scrollHeight;

    if (!element.contains(i.scrollbarXRail)) {
      // clean up and append
      queryChildren(element, cls.element.rail('x')).forEach(function (el) {
        return remove(el);
      });
      element.appendChild(i.scrollbarXRail);
    }

    if (!element.contains(i.scrollbarYRail)) {
      // clean up and append
      queryChildren(element, cls.element.rail('y')).forEach(function (el) {
        return remove(el);
      });
      element.appendChild(i.scrollbarYRail);
    }

    if (!i.settings.suppressScrollX && i.containerWidth + i.settings.scrollXMarginOffset < i.contentWidth) {
      i.scrollbarXActive = true;
      i.railXWidth = i.containerWidth - i.railXMarginWidth;
      i.railXRatio = i.containerWidth / i.railXWidth;
      i.scrollbarXWidth = getThumbSize(i, toInt(i.railXWidth * i.containerWidth / i.contentWidth));
      i.scrollbarXLeft = toInt((i.negativeScrollAdjustment + element.scrollLeft) * (i.railXWidth - i.scrollbarXWidth) / (i.contentWidth - i.containerWidth));
    } else {
      i.scrollbarXActive = false;
    }

    if (!i.settings.suppressScrollY && i.containerHeight + i.settings.scrollYMarginOffset < i.contentHeight) {
      i.scrollbarYActive = true;
      i.railYHeight = i.containerHeight - i.railYMarginHeight;
      i.railYRatio = i.containerHeight / i.railYHeight;
      i.scrollbarYHeight = getThumbSize(i, toInt(i.railYHeight * i.containerHeight / i.contentHeight));
      i.scrollbarYTop = toInt(roundedScrollTop * (i.railYHeight - i.scrollbarYHeight) / (i.contentHeight - i.containerHeight));
    } else {
      i.scrollbarYActive = false;
    }

    if (i.scrollbarXLeft >= i.railXWidth - i.scrollbarXWidth) {
      i.scrollbarXLeft = i.railXWidth - i.scrollbarXWidth;
    }

    if (i.scrollbarYTop >= i.railYHeight - i.scrollbarYHeight) {
      i.scrollbarYTop = i.railYHeight - i.scrollbarYHeight;
    }

    updateCss(element, i);

    if (i.scrollbarXActive) {
      element.classList.add(cls.state.active('x'));
    } else {
      element.classList.remove(cls.state.active('x'));
      i.scrollbarXWidth = 0;
      i.scrollbarXLeft = 0;
      element.scrollLeft = i.isRtl === true ? i.contentWidth : 0;
    }

    if (i.scrollbarYActive) {
      element.classList.add(cls.state.active('y'));
    } else {
      element.classList.remove(cls.state.active('y'));
      i.scrollbarYHeight = 0;
      i.scrollbarYTop = 0;
      element.scrollTop = 0;
    }
  }

  function getThumbSize(i, thumbSize) {
    if (i.settings.minScrollbarLength) {
      thumbSize = Math.max(thumbSize, i.settings.minScrollbarLength);
    }

    if (i.settings.maxScrollbarLength) {
      thumbSize = Math.min(thumbSize, i.settings.maxScrollbarLength);
    }

    return thumbSize;
  }

  function updateCss(element, i) {
    var xRailOffset = {
      width: i.railXWidth
    };
    var roundedScrollTop = Math.floor(element.scrollTop);

    if (i.isRtl) {
      xRailOffset.left = i.negativeScrollAdjustment + element.scrollLeft + i.containerWidth - i.contentWidth;
    } else {
      xRailOffset.left = element.scrollLeft;
    }

    if (i.isScrollbarXUsingBottom) {
      xRailOffset.bottom = i.scrollbarXBottom - roundedScrollTop;
    } else {
      xRailOffset.top = i.scrollbarXTop + roundedScrollTop;
    }

    set(i.scrollbarXRail, xRailOffset);
    var yRailOffset = {
      top: roundedScrollTop,
      height: i.railYHeight
    };

    if (i.isScrollbarYUsingRight) {
      if (i.isRtl) {
        yRailOffset.right = i.contentWidth - (i.negativeScrollAdjustment + element.scrollLeft) - i.scrollbarYRight - i.scrollbarYOuterWidth - 9;
      } else {
        yRailOffset.right = i.scrollbarYRight - element.scrollLeft;
      }
    } else {
      if (i.isRtl) {
        yRailOffset.left = i.negativeScrollAdjustment + element.scrollLeft + i.containerWidth * 2 - i.contentWidth - i.scrollbarYLeft - i.scrollbarYOuterWidth;
      } else {
        yRailOffset.left = i.scrollbarYLeft + element.scrollLeft;
      }
    }

    set(i.scrollbarYRail, yRailOffset);
    set(i.scrollbarX, {
      left: i.scrollbarXLeft,
      width: i.scrollbarXWidth - i.railBorderXWidth
    });
    set(i.scrollbarY, {
      top: i.scrollbarYTop,
      height: i.scrollbarYHeight - i.railBorderYWidth
    });
  }

  function clickRail(i) {
    var element = i.element;
    i.event.bind(i.scrollbarY, 'mousedown', function (e) {
      return e.stopPropagation();
    });
    i.event.bind(i.scrollbarYRail, 'mousedown', function (e) {
      var positionTop = e.pageY - window.pageYOffset - i.scrollbarYRail.getBoundingClientRect().top;
      var direction = positionTop > i.scrollbarYTop ? 1 : -1;
      i.element.scrollTop += direction * i.containerHeight;
      updateGeometry(i);
      e.stopPropagation();
    });
    i.event.bind(i.scrollbarX, 'mousedown', function (e) {
      return e.stopPropagation();
    });
    i.event.bind(i.scrollbarXRail, 'mousedown', function (e) {
      var positionLeft = e.pageX - window.pageXOffset - i.scrollbarXRail.getBoundingClientRect().left;
      var direction = positionLeft > i.scrollbarXLeft ? 1 : -1;
      i.element.scrollLeft += direction * i.containerWidth;
      updateGeometry(i);
      e.stopPropagation();
    });
  }

  function dragThumb(i) {
    bindMouseScrollHandler(i, ['containerWidth', 'contentWidth', 'pageX', 'railXWidth', 'scrollbarX', 'scrollbarXWidth', 'scrollLeft', 'x', 'scrollbarXRail']);
    bindMouseScrollHandler(i, ['containerHeight', 'contentHeight', 'pageY', 'railYHeight', 'scrollbarY', 'scrollbarYHeight', 'scrollTop', 'y', 'scrollbarYRail']);
  }

  function bindMouseScrollHandler(i, ref) {
    var containerHeight = ref[0];
    var contentHeight = ref[1];
    var pageY = ref[2];
    var railYHeight = ref[3];
    var scrollbarY = ref[4];
    var scrollbarYHeight = ref[5];
    var scrollTop = ref[6];
    var y = ref[7];
    var scrollbarYRail = ref[8];
    var element = i.element;
    var startingScrollTop = null;
    var startingMousePageY = null;
    var scrollBy = null;

    function mouseMoveHandler(e) {
      if (e.touches && e.touches[0]) {
        e[pageY] = e.touches[0].pageY;
      }

      element[scrollTop] = startingScrollTop + scrollBy * (e[pageY] - startingMousePageY);
      addScrollingClass(i, y);
      updateGeometry(i);
      e.stopPropagation();
      e.preventDefault();
    }

    function mouseUpHandler() {
      removeScrollingClass(i, y);
      i[scrollbarYRail].classList.remove(cls.state.clicking);
      i.event.unbind(i.ownerDocument, 'mousemove', mouseMoveHandler);
    }

    function bindMoves(e, touchMode) {
      startingScrollTop = element[scrollTop];

      if (touchMode && e.touches) {
        e[pageY] = e.touches[0].pageY;
      }

      startingMousePageY = e[pageY];
      scrollBy = (i[contentHeight] - i[containerHeight]) / (i[railYHeight] - i[scrollbarYHeight]);

      if (!touchMode) {
        i.event.bind(i.ownerDocument, 'mousemove', mouseMoveHandler);
        i.event.once(i.ownerDocument, 'mouseup', mouseUpHandler);
        e.preventDefault();
      } else {
        i.event.bind(i.ownerDocument, 'touchmove', mouseMoveHandler);
      }

      i[scrollbarYRail].classList.add(cls.state.clicking);
      e.stopPropagation();
    }

    i.event.bind(i[scrollbarY], 'mousedown', function (e) {
      bindMoves(e);
    });
    i.event.bind(i[scrollbarY], 'touchstart', function (e) {
      bindMoves(e, true);
    });
  }

  function keyboard(i) {
    var element = i.element;

    var elementHovered = function elementHovered() {
      return matches(element, ':hover');
    };

    var scrollbarFocused = function scrollbarFocused() {
      return matches(i.scrollbarX, ':focus') || matches(i.scrollbarY, ':focus');
    };

    function shouldPreventDefault(deltaX, deltaY) {
      var scrollTop = Math.floor(element.scrollTop);

      if (deltaX === 0) {
        if (!i.scrollbarYActive) {
          return false;
        }

        if (scrollTop === 0 && deltaY > 0 || scrollTop >= i.contentHeight - i.containerHeight && deltaY < 0) {
          return !i.settings.wheelPropagation;
        }
      }

      var scrollLeft = element.scrollLeft;

      if (deltaY === 0) {
        if (!i.scrollbarXActive) {
          return false;
        }

        if (scrollLeft === 0 && deltaX < 0 || scrollLeft >= i.contentWidth - i.containerWidth && deltaX > 0) {
          return !i.settings.wheelPropagation;
        }
      }

      return true;
    }

    i.event.bind(i.ownerDocument, 'keydown', function (e) {
      if (e.isDefaultPrevented && e.isDefaultPrevented() || e.defaultPrevented) {
        return;
      }

      if (!elementHovered() && !scrollbarFocused()) {
        return;
      }

      var activeElement = document.activeElement ? document.activeElement : i.ownerDocument.activeElement;

      if (activeElement) {
        if (activeElement.tagName === 'IFRAME') {
          activeElement = activeElement.contentDocument.activeElement;
        } else {
          // go deeper if element is a webcomponent
          while (activeElement.shadowRoot) {
            activeElement = activeElement.shadowRoot.activeElement;
          }
        }

        if (isEditable(activeElement)) {
          return;
        }
      }

      var deltaX = 0;
      var deltaY = 0;

      switch (e.which) {
        case 37:
          // left
          if (e.metaKey) {
            deltaX = -i.contentWidth;
          } else if (e.altKey) {
            deltaX = -i.containerWidth;
          } else {
            deltaX = -30;
          }

          break;

        case 38:
          // up
          if (e.metaKey) {
            deltaY = i.contentHeight;
          } else if (e.altKey) {
            deltaY = i.containerHeight;
          } else {
            deltaY = 30;
          }

          break;

        case 39:
          // right
          if (e.metaKey) {
            deltaX = i.contentWidth;
          } else if (e.altKey) {
            deltaX = i.containerWidth;
          } else {
            deltaX = 30;
          }

          break;

        case 40:
          // down
          if (e.metaKey) {
            deltaY = -i.contentHeight;
          } else if (e.altKey) {
            deltaY = -i.containerHeight;
          } else {
            deltaY = -30;
          }

          break;

        case 32:
          // space bar
          if (e.shiftKey) {
            deltaY = i.containerHeight;
          } else {
            deltaY = -i.containerHeight;
          }

          break;

        case 33:
          // page up
          deltaY = i.containerHeight;
          break;

        case 34:
          // page down
          deltaY = -i.containerHeight;
          break;

        case 36:
          // home
          deltaY = i.contentHeight;
          break;

        case 35:
          // end
          deltaY = -i.contentHeight;
          break;

        default:
          return;
      }

      if (i.settings.suppressScrollX && deltaX !== 0) {
        return;
      }

      if (i.settings.suppressScrollY && deltaY !== 0) {
        return;
      }

      element.scrollTop -= deltaY;
      element.scrollLeft += deltaX;
      updateGeometry(i);

      if (shouldPreventDefault(deltaX, deltaY)) {
        e.preventDefault();
      }
    });
  }

  function wheel(i) {
    var element = i.element;

    function shouldPreventDefault(deltaX, deltaY) {
      var roundedScrollTop = Math.floor(element.scrollTop);
      var isTop = element.scrollTop === 0;
      var isBottom = roundedScrollTop + element.offsetHeight === element.scrollHeight;
      var isLeft = element.scrollLeft === 0;
      var isRight = element.scrollLeft + element.offsetWidth === element.scrollWidth;
      var hitsBound; // pick axis with primary direction

      if (Math.abs(deltaY) > Math.abs(deltaX)) {
        hitsBound = isTop || isBottom;
      } else {
        hitsBound = isLeft || isRight;
      }

      return hitsBound ? !i.settings.wheelPropagation : true;
    }

    function getDeltaFromEvent(e) {
      var deltaX = e.deltaX;
      var deltaY = -1 * e.deltaY;

      if (typeof deltaX === 'undefined' || typeof deltaY === 'undefined') {
        // OS X Safari
        deltaX = -1 * e.wheelDeltaX / 6;
        deltaY = e.wheelDeltaY / 6;
      }

      if (e.deltaMode && e.deltaMode === 1) {
        // Firefox in deltaMode 1: Line scrolling
        deltaX *= 10;
        deltaY *= 10;
      }

      if (deltaX !== deltaX && deltaY !== deltaY
      /* NaN checks */
      ) {
          // IE in some mouse drivers
          deltaX = 0;
          deltaY = e.wheelDelta;
        }

      if (e.shiftKey) {
        // reverse axis with shift key
        return [-deltaY, -deltaX];
      }

      return [deltaX, deltaY];
    }

    function shouldBeConsumedByChild(target, deltaX, deltaY) {
      // FIXME: this is a workaround for <select> issue in FF and IE #571
      if (!env.isWebKit && element.querySelector('select:focus')) {
        return true;
      }

      if (!element.contains(target)) {
        return false;
      }

      var cursor = target;

      while (cursor && cursor !== element) {
        if (cursor.classList.contains(cls.element.consuming)) {
          return true;
        }

        var style = get(cursor); // if deltaY && vertical scrollable

        if (deltaY && style.overflowY.match(/(scroll|auto)/)) {
          var maxScrollTop = cursor.scrollHeight - cursor.clientHeight;

          if (maxScrollTop > 0) {
            if (cursor.scrollTop > 0 && deltaY < 0 || cursor.scrollTop < maxScrollTop && deltaY > 0) {
              return true;
            }
          }
        } // if deltaX && horizontal scrollable


        if (deltaX && style.overflowX.match(/(scroll|auto)/)) {
          var maxScrollLeft = cursor.scrollWidth - cursor.clientWidth;

          if (maxScrollLeft > 0) {
            if (cursor.scrollLeft > 0 && deltaX < 0 || cursor.scrollLeft < maxScrollLeft && deltaX > 0) {
              return true;
            }
          }
        }

        cursor = cursor.parentNode;
      }

      return false;
    }

    function mousewheelHandler(e) {
      var ref = getDeltaFromEvent(e);
      var deltaX = ref[0];
      var deltaY = ref[1];

      if (shouldBeConsumedByChild(e.target, deltaX, deltaY)) {
        return;
      }

      var shouldPrevent = false;

      if (!i.settings.useBothWheelAxes) {
        // deltaX will only be used for horizontal scrolling and deltaY will
        // only be used for vertical scrolling - this is the default
        element.scrollTop -= deltaY * i.settings.wheelSpeed;
        element.scrollLeft += deltaX * i.settings.wheelSpeed;
      } else if (i.scrollbarYActive && !i.scrollbarXActive) {
        // only vertical scrollbar is active and useBothWheelAxes option is
        // active, so let's scroll vertical bar using both mouse wheel axes
        if (deltaY) {
          element.scrollTop -= deltaY * i.settings.wheelSpeed;
        } else {
          element.scrollTop += deltaX * i.settings.wheelSpeed;
        }

        shouldPrevent = true;
      } else if (i.scrollbarXActive && !i.scrollbarYActive) {
        // useBothWheelAxes and only horizontal bar is active, so use both
        // wheel axes for horizontal bar
        if (deltaX) {
          element.scrollLeft += deltaX * i.settings.wheelSpeed;
        } else {
          element.scrollLeft -= deltaY * i.settings.wheelSpeed;
        }

        shouldPrevent = true;
      }

      updateGeometry(i);
      shouldPrevent = shouldPrevent || shouldPreventDefault(deltaX, deltaY);

      if (shouldPrevent && !e.ctrlKey) {
        e.stopPropagation();
        e.preventDefault();
      }
    }

    if (typeof window.onwheel !== 'undefined') {
      i.event.bind(element, 'wheel', mousewheelHandler);
    } else if (typeof window.onmousewheel !== 'undefined') {
      i.event.bind(element, 'mousewheel', mousewheelHandler);
    }
  }

  function touch(i) {
    if (!env.supportsTouch && !env.supportsIePointer) {
      return;
    }

    var element = i.element;

    function shouldPrevent(deltaX, deltaY) {
      var scrollTop = Math.floor(element.scrollTop);
      var scrollLeft = element.scrollLeft;
      var magnitudeX = Math.abs(deltaX);
      var magnitudeY = Math.abs(deltaY);

      if (magnitudeY > magnitudeX) {
        // user is perhaps trying to swipe up/down the page
        if (deltaY < 0 && scrollTop === i.contentHeight - i.containerHeight || deltaY > 0 && scrollTop === 0) {
          // set prevent for mobile Chrome refresh
          return window.scrollY === 0 && deltaY > 0 && env.isChrome;
        }
      } else if (magnitudeX > magnitudeY) {
        // user is perhaps trying to swipe left/right across the page
        if (deltaX < 0 && scrollLeft === i.contentWidth - i.containerWidth || deltaX > 0 && scrollLeft === 0) {
          return true;
        }
      }

      return true;
    }

    function applyTouchMove(differenceX, differenceY) {
      element.scrollTop -= differenceY;
      element.scrollLeft -= differenceX;
      updateGeometry(i);
    }

    var startOffset = {};
    var startTime = 0;
    var speed = {};
    var easingLoop = null;

    function getTouch(e) {
      if (e.targetTouches) {
        return e.targetTouches[0];
      } else {
        // Maybe IE pointer
        return e;
      }
    }

    function shouldHandle(e) {
      if (e.pointerType && e.pointerType === 'pen' && e.buttons === 0) {
        return false;
      }

      if (e.targetTouches && e.targetTouches.length === 1) {
        return true;
      }

      if (e.pointerType && e.pointerType !== 'mouse' && e.pointerType !== e.MSPOINTER_TYPE_MOUSE) {
        return true;
      }

      return false;
    }

    function touchStart(e) {
      if (!shouldHandle(e)) {
        return;
      }

      var touch = getTouch(e);
      startOffset.pageX = touch.pageX;
      startOffset.pageY = touch.pageY;
      startTime = new Date().getTime();

      if (easingLoop !== null) {
        clearInterval(easingLoop);
      }
    }

    function shouldBeConsumedByChild(target, deltaX, deltaY) {
      if (!element.contains(target)) {
        return false;
      }

      var cursor = target;

      while (cursor && cursor !== element) {
        if (cursor.classList.contains(cls.element.consuming)) {
          return true;
        }

        var style = get(cursor); // if deltaY && vertical scrollable

        if (deltaY && style.overflowY.match(/(scroll|auto)/)) {
          var maxScrollTop = cursor.scrollHeight - cursor.clientHeight;

          if (maxScrollTop > 0) {
            if (cursor.scrollTop > 0 && deltaY < 0 || cursor.scrollTop < maxScrollTop && deltaY > 0) {
              return true;
            }
          }
        } // if deltaX && horizontal scrollable


        if (deltaX && style.overflowX.match(/(scroll|auto)/)) {
          var maxScrollLeft = cursor.scrollWidth - cursor.clientWidth;

          if (maxScrollLeft > 0) {
            if (cursor.scrollLeft > 0 && deltaX < 0 || cursor.scrollLeft < maxScrollLeft && deltaX > 0) {
              return true;
            }
          }
        }

        cursor = cursor.parentNode;
      }

      return false;
    }

    function touchMove(e) {
      if (shouldHandle(e)) {
        var touch = getTouch(e);
        var currentOffset = {
          pageX: touch.pageX,
          pageY: touch.pageY
        };
        var differenceX = currentOffset.pageX - startOffset.pageX;
        var differenceY = currentOffset.pageY - startOffset.pageY;

        if (shouldBeConsumedByChild(e.target, differenceX, differenceY)) {
          return;
        }

        applyTouchMove(differenceX, differenceY);
        startOffset = currentOffset;
        var currentTime = new Date().getTime();
        var timeGap = currentTime - startTime;

        if (timeGap > 0) {
          speed.x = differenceX / timeGap;
          speed.y = differenceY / timeGap;
          startTime = currentTime;
        }

        if (shouldPrevent(differenceX, differenceY)) {
          e.preventDefault();
        }
      }
    }

    function touchEnd() {
      if (i.settings.swipeEasing) {
        clearInterval(easingLoop);
        easingLoop = setInterval(function () {
          if (i.isInitialized) {
            clearInterval(easingLoop);
            return;
          }

          if (!speed.x && !speed.y) {
            clearInterval(easingLoop);
            return;
          }

          if (Math.abs(speed.x) < 0.01 && Math.abs(speed.y) < 0.01) {
            clearInterval(easingLoop);
            return;
          }

          applyTouchMove(speed.x * 30, speed.y * 30);
          speed.x *= 0.8;
          speed.y *= 0.8;
        }, 10);
      }
    }

    if (env.supportsTouch) {
      i.event.bind(element, 'touchstart', touchStart);
      i.event.bind(element, 'touchmove', touchMove);
      i.event.bind(element, 'touchend', touchEnd);
    } else if (env.supportsIePointer) {
      if (window.PointerEvent) {
        i.event.bind(element, 'pointerdown', touchStart);
        i.event.bind(element, 'pointermove', touchMove);
        i.event.bind(element, 'pointerup', touchEnd);
      } else if (window.MSPointerEvent) {
        i.event.bind(element, 'MSPointerDown', touchStart);
        i.event.bind(element, 'MSPointerMove', touchMove);
        i.event.bind(element, 'MSPointerUp', touchEnd);
      }
    }
  }

  var defaultSettings = function defaultSettings() {
    return {
      handlers: ['click-rail', 'drag-thumb', 'keyboard', 'wheel', 'touch'],
      maxScrollbarLength: null,
      minScrollbarLength: null,
      scrollingThreshold: 1000,
      scrollXMarginOffset: 0,
      scrollYMarginOffset: 0,
      suppressScrollX: false,
      suppressScrollY: false,
      swipeEasing: true,
      useBothWheelAxes: false,
      wheelPropagation: true,
      wheelSpeed: 1
    };
  };

  var handlers = {
    'click-rail': clickRail,
    'drag-thumb': dragThumb,
    keyboard: keyboard,
    wheel: wheel,
    touch: touch
  };

  var PerfectScrollbar = function PerfectScrollbar(element, userSettings) {
    var this$1 = this;
    if (userSettings === void 0) userSettings = {};

    if (typeof element === 'string') {
      element = document.querySelector(element);
    }

    if (!element || !element.nodeName) {
      throw new Error('no element is specified to initialize PerfectScrollbar');
    }

    this.element = element;
    element.classList.add(cls.main);
    this.settings = defaultSettings();

    for (var key in userSettings) {
      this.settings[key] = userSettings[key];
    }

    this.containerWidth = null;
    this.containerHeight = null;
    this.contentWidth = null;
    this.contentHeight = null;

    var focus = function focus() {
      return element.classList.add(cls.state.focus);
    };

    var blur = function blur() {
      return element.classList.remove(cls.state.focus);
    };

    this.isRtl = get(element).direction === 'rtl';

    if (this.isRtl === true) {
      element.classList.add(cls.rtl);
    }

    this.isNegativeScroll = function () {
      var originalScrollLeft = element.scrollLeft;
      var result = null;
      element.scrollLeft = -1;
      result = element.scrollLeft < 0;
      element.scrollLeft = originalScrollLeft;
      return result;
    }();

    this.negativeScrollAdjustment = this.isNegativeScroll ? element.scrollWidth - element.clientWidth : 0;
    this.event = new EventManager();
    this.ownerDocument = element.ownerDocument || document;
    this.scrollbarXRail = div(cls.element.rail('x'));
    element.appendChild(this.scrollbarXRail);
    this.scrollbarX = div(cls.element.thumb('x'));
    this.scrollbarXRail.appendChild(this.scrollbarX);
    this.scrollbarX.setAttribute('tabindex', 0);
    this.event.bind(this.scrollbarX, 'focus', focus);
    this.event.bind(this.scrollbarX, 'blur', blur);
    this.scrollbarXActive = null;
    this.scrollbarXWidth = null;
    this.scrollbarXLeft = null;
    var railXStyle = get(this.scrollbarXRail);
    this.scrollbarXBottom = parseInt(railXStyle.bottom, 10);

    if (isNaN(this.scrollbarXBottom)) {
      this.isScrollbarXUsingBottom = false;
      this.scrollbarXTop = toInt(railXStyle.top);
    } else {
      this.isScrollbarXUsingBottom = true;
    }

    this.railBorderXWidth = toInt(railXStyle.borderLeftWidth) + toInt(railXStyle.borderRightWidth); // Set rail to display:block to calculate margins

    set(this.scrollbarXRail, {
      display: 'block'
    });
    this.railXMarginWidth = toInt(railXStyle.marginLeft) + toInt(railXStyle.marginRight);
    set(this.scrollbarXRail, {
      display: ''
    });
    this.railXWidth = null;
    this.railXRatio = null;
    this.scrollbarYRail = div(cls.element.rail('y'));
    element.appendChild(this.scrollbarYRail);
    this.scrollbarY = div(cls.element.thumb('y'));
    this.scrollbarYRail.appendChild(this.scrollbarY);
    this.scrollbarY.setAttribute('tabindex', 0);
    this.event.bind(this.scrollbarY, 'focus', focus);
    this.event.bind(this.scrollbarY, 'blur', blur);
    this.scrollbarYActive = null;
    this.scrollbarYHeight = null;
    this.scrollbarYTop = null;
    var railYStyle = get(this.scrollbarYRail);
    this.scrollbarYRight = parseInt(railYStyle.right, 10);

    if (isNaN(this.scrollbarYRight)) {
      this.isScrollbarYUsingRight = false;
      this.scrollbarYLeft = toInt(railYStyle.left);
    } else {
      this.isScrollbarYUsingRight = true;
    }

    this.scrollbarYOuterWidth = this.isRtl ? outerWidth(this.scrollbarY) : null;
    this.railBorderYWidth = toInt(railYStyle.borderTopWidth) + toInt(railYStyle.borderBottomWidth);
    set(this.scrollbarYRail, {
      display: 'block'
    });
    this.railYMarginHeight = toInt(railYStyle.marginTop) + toInt(railYStyle.marginBottom);
    set(this.scrollbarYRail, {
      display: ''
    });
    this.railYHeight = null;
    this.railYRatio = null;
    this.reach = {
      x: element.scrollLeft <= 0 ? 'start' : element.scrollLeft >= this.contentWidth - this.containerWidth ? 'end' : null,
      y: element.scrollTop <= 0 ? 'start' : element.scrollTop >= this.contentHeight - this.containerHeight ? 'end' : null
    };
    this.isAlive = true;
    this.settings.handlers.forEach(function (handlerName) {
      return handlers[handlerName](this$1);
    });
    this.lastScrollTop = Math.floor(element.scrollTop); // for onScroll only

    this.lastScrollLeft = element.scrollLeft; // for onScroll only

    this.event.bind(this.element, 'scroll', function (e) {
      return this$1.onScroll(e);
    });
    updateGeometry(this);
  };

  PerfectScrollbar.prototype.update = function update() {
    if (!this.isAlive) {
      return;
    } // Recalcuate negative scrollLeft adjustment


    this.negativeScrollAdjustment = this.isNegativeScroll ? this.element.scrollWidth - this.element.clientWidth : 0; // Recalculate rail margins

    set(this.scrollbarXRail, {
      display: 'block'
    });
    set(this.scrollbarYRail, {
      display: 'block'
    });
    this.railXMarginWidth = toInt(get(this.scrollbarXRail).marginLeft) + toInt(get(this.scrollbarXRail).marginRight);
    this.railYMarginHeight = toInt(get(this.scrollbarYRail).marginTop) + toInt(get(this.scrollbarYRail).marginBottom); // Hide scrollbars not to affect scrollWidth and scrollHeight

    set(this.scrollbarXRail, {
      display: 'none'
    });
    set(this.scrollbarYRail, {
      display: 'none'
    });
    updateGeometry(this);
    processScrollDiff(this, 'top', 0, false, true);
    processScrollDiff(this, 'left', 0, false, true);
    set(this.scrollbarXRail, {
      display: ''
    });
    set(this.scrollbarYRail, {
      display: ''
    });
  };

  PerfectScrollbar.prototype.onScroll = function onScroll(e) {
    if (!this.isAlive) {
      return;
    }

    updateGeometry(this);
    processScrollDiff(this, 'top', this.element.scrollTop - this.lastScrollTop);
    processScrollDiff(this, 'left', this.element.scrollLeft - this.lastScrollLeft);
    this.lastScrollTop = Math.floor(this.element.scrollTop);
    this.lastScrollLeft = this.element.scrollLeft;
  };

  PerfectScrollbar.prototype.destroy = function destroy() {
    if (!this.isAlive) {
      return;
    }

    this.event.unbindAll();
    remove(this.scrollbarX);
    remove(this.scrollbarY);
    remove(this.scrollbarXRail);
    remove(this.scrollbarYRail);
    this.removePsClasses(); // unset elements

    this.element = null;
    this.scrollbarX = null;
    this.scrollbarY = null;
    this.scrollbarXRail = null;
    this.scrollbarYRail = null;
    this.isAlive = false;
  };

  PerfectScrollbar.prototype.removePsClasses = function removePsClasses() {
    this.element.className = this.element.className.split(' ').filter(function (name) {
      return !name.match(/^ps([-_].+|)$/);
    }).join(' ');
  };

  return PerfectScrollbar;
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);

var $ = jQuery.noConflict();
'use strict';

var equalHeightsItems = {
  /**
   * @description Cache dom and strings
   * @type {object}
   */

  /** @description Initialize */
  init: function init() {
    this.equalHeight();
  },

  /** @description slider example description e.g Banner slider */
  equalHeight: function equalHeight() {
    _global__WEBPACK_IMPORTED_MODULE_0__["default"].equalHeights($('.icons-equal-heights'));

    if (_global__WEBPACK_IMPORTED_MODULE_0__["default"].varsWindowWidth > 991) {
      _global__WEBPACK_IMPORTED_MODULE_0__["default"].equalHeights($('.equal-heights'));
      _global__WEBPACK_IMPORTED_MODULE_0__["default"].equalHeights($('.cards-equal-heights'));
    } // Global.equalHeights($('.service-equal-heights'));


    _global__WEBPACK_IMPORTED_MODULE_0__["default"].equalHeights($('.services-block-equal-heights'));
  }
};
/* harmony default export */ __webpack_exports__["default"] = (equalHeightsItems);

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
var $ = jQuery.noConflict();

'use strict';

var menuMain = {
  /**
   * @description Cache dom and strings
   * @type {object}
   */
  $domMenuBtn: $('.js-menu-btn-v2'),
  $domMenuOuter: $('.js-nav-outer-v2'),
  $domMenuInner: $('.js-nav-inner-v2'),
  $domMenuIcon: $('.js-nav-icon-v2'),
  $domMenuSub: $('.sub-menu-v2'),
  $domHeader: $('.site-header'),
  $search: $('.search-v2'),
  slMenuIcon: '.js-nav-icon-v2',
  slMenuSub: '.sub-menu-v2',
  classActive: 'is-active',
  timeout: null,

  /** @description Initialize */
  init: function init() {
    this.bindEvents();
    this.subIconAppend();
    this.toggleMainSubMenu();
  },

  /** @description Bind Events */
  bindEvents: function bindEvents() {
    this.$domMenuBtn.on('click', this.toggleMenu.bind(this));
    this.$domMenuIcon.on('click', this.toggleSubMenu.bind(this));
    _global__WEBPACK_IMPORTED_MODULE_0__["default"].escKey(this.closeMenu.bind(this)); // Global.clickOutsideContainer(Global.$domBody, this.$domMenuInner, this.$domMenuBtn, this.closeMenu.bind(this));
  },
  toggleMenu: function toggleMenu() {
    if (!this.$domMenuBtn.hasClass(this.classActive)) {
      this.$domMenuBtn.addClass(this.classActive);
      this.$domMenuOuter.addClass(this.classActive);
      this.$search.addClass(this.classActive);
    } else {
      this.closeMenu();
    }
  },
  toggleSubMenu: function toggleSubMenu(e) {
    var icon = $(e.target.closest(this.slMenuIcon));
    var ul = icon.siblings(this.slMenuSub);

    if (!icon.hasClass(this.classActive)) {
      icon.addClass(this.classActive);
      ul.slideDown();
    } else {
      icon.removeClass(this.classActive);
      icon.parent().find(this.slMenuIcon).removeClass(this.classActive);
      ul.slideUp();
      ul.find(this.slMenuSub).slideUp();
    }
  },
  closeMenu: function closeMenu() {
    var _this = this;

    this.$domMenuBtn.removeClass(this.classActive);
    this.$domMenuOuter.removeClass(this.classActive);
    this.$search.removeClass(this.classActive); // timeout should match the selectors CSS transition duration property

    clearTimeout(this.timeout);
    this.timeout = setTimeout(function () {
      _this.$domMenuIcon.removeClass(_this.classActive);

      _this.$domMenuSub.slideUp();
    }, 300);
  },
  subIconAppend: function subIconAppend() {
    if (_global__WEBPACK_IMPORTED_MODULE_0__["default"].varsWindowWidth < 1257) {
      $('.menu-item-has-children, .nav-list--has-sub-menu').each(function (i, el) {
        $(el).append('<span class="sub-icon" data-open-sub><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M7.406 8.578L12 13.172l4.594-4.594L18 9.984l-6 6-6-6z"/></svg></svg></span>');
      });
    }
  },
  toggleMainSubMenu: function toggleMainSubMenu() {
    $(document).on('click', '[data-open-sub]', function (e) {
      var _self = $(e.currentTarget);

      console.log(_self);

      if (_global__WEBPACK_IMPORTED_MODULE_0__["default"].varsWindowWidth < 1257) {
        if (_self.hasClass('open')) {
          _self.removeClass('open');

          _self.parent('li, ul').removeClass('open');

          _self.siblings('.sub-menu, .nav-list__sub-menu').slideUp();

          _self.parent('li, ul').find('.sub-icon').removeClass('open');

          _self.parent('li, ul').find('.sub-menu, .nav-list__sub-menu').removeClass('open').slideUp();
        } else {
          _self.addClass('open');

          _self.parent('li, ul').addClass('open');

          _self.siblings('.sub-menu, .nav-list__sub-menu').slideDown();

          _self.parents('li.open, ul.open').siblings().find('.sub-icon').removeClass('open');

          _self.parents('li.open, ul.open').siblings().find('.sub-menu, .nav-list__sub-menu').slideUp();
        }
      }
    });
  }
};
$(document).on('scroll', function () {
  var scrollTop = $(document).scrollTop();

  if (scrollTop > 10) {
    menuMain.$domHeader.addClass('scroll');
  } else {
    menuMain.$domHeader.removeClass('scroll');
  }
});
/* harmony default export */ __webpack_exports__["default"] = (menuMain);

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var $ = jQuery.noConflict();
'use strict';

var ChangeLayout = {
  /**
   * @description Cache dom and strings
   * @type {object}
   */

  /** @description Initialize */
  init: function init() {
    if ($(window).width() <= 375) {
      this.moveElement();
    }
  },
  moveElement: function moveElement() {
    $('.tag-description .btn--border').appendTo('.tag-description-listing');
    $('.simple-slider-arrows').appendTo('.news-slider');
    $('.case-listing .intro-row .case-listing-right').appendTo('.case-listing .case-listing-wrapper');
    $('.simple-slider .simple-slider-arrows').appendTo('.simple-slider .simple-slider-inner');
    $('.video-gallery .btn').appendTo('.video-gallery-items');
    $('.sources .case-listing-right .btn').appendTo('.sources');
  }
};
/* harmony default export */ __webpack_exports__["default"] = (ChangeLayout);

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);

var $ = jQuery.noConflict();
'use strict';
/**
 * @description In order to create link that scrolls to certain section, simply place '#scroll-section-example' to a desired tag and id with same value to the section page should scroll to.
 * @description Alternately, you can enable any URL with# to autoscroll on page load. For example: some - website.com / #scroll - section - example
 * @example tag: <a class="btn" href="#scroll-section-example"> will scroll to: <div class="some-section" id="scroll-section-example">
 */


var ServicesHeight = {
  /**
   * @description Cache dom and strings
   * @type {object}
   */
  $row: $('.services-wrapper .row'),

  /** @description Initialize */
  init: function init() {
    _global__WEBPACK_IMPORTED_MODULE_0__["default"].equalHeights(ServicesHeight.$row);
  }
};
/* harmony default export */ __webpack_exports__["default"] = (ServicesHeight);

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var $ = jQuery.noConflict();
'use strict';

var stickyScroll = {
  /**
   * @description Cache dom and strings
   * @type {object}
   */
  $element: $('.filter-section'),
  $domReference: $('.reference'),
  $stickClass: $('fixed'),
  $domHeader: $('.site-header'),
  init: function init() {
    if ($('.reference').length > 0) this.filterStick();
  },
  filterStick: function filterStick() {
    $(window).on('scroll', function () {
      var elementTop = stickyScroll.$domReference.offset().top;
      var scrollTop = $(window).scrollTop();
      var headerHeight = stickyScroll.$domHeader.outerHeight();

      if (scrollTop + headerHeight > elementTop) {
        stickyScroll.$element.addClass('fixed');
      } else {
        stickyScroll.$element.removeClass('fixed');
      }
    });
  }
};
/* harmony default export */ __webpack_exports__["default"] = (stickyScroll);

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);

var $ = jQuery.noConflict();
'use strict';

var MegaMenu = {
  /**
   * @description Cache dom and strings
   * @type {object}
   */
  $megamenu: $('.megamenu'),
  $megamenuNavItem: $('.js-megamenu'),
  $megamenuToggle: $('.toggle-mega-menu'),

  /** @description Initialize */
  init: function init() {
    this.megamenu();
  },

  /** @description slider example description e.g Banner slider */
  megamenu: function megamenu() {
    console.log(111);
    $('.js-megamenu').hover(function () {
      $(this).find('.megamenu').addClass('active');
      $(this).addClass('active');
    });
    $('.js-megamenu').mouseleave(function () {
      $('.megamenu').removeClass('active');
      $('.js-megamenu').removeClass('active');
    });
    /*
    MegaMenu.$megamenuNavItem.on('hover', function() {
    	$(this).find('.megamenu').addClass('active');
    	$(this).addClass('active');
    });
    		MegaMenu.$megamenuNavItem.mouseleave(function() {
    	MegaMenu.$megamenu.removeClass('active');
    	MegaMenu.$megamenuNavItem.removeClass('active');
    });
    */

    if (_global__WEBPACK_IMPORTED_MODULE_0__["default"].varsWindowWidth < 1257) {
      $('.toggle-mega-menu').click(function () {
        $(this).next().slideToggle();
        $(this).toggleClass('rotate');
      });
      /*
      MegaMenu.$megamenuToggle.click(function() {
      	$(this).next().slideToggle();
      	$(this).toggleClass('rotate');
      });
      */
    }

    $('.js-megamenu-wrap').each(function (i, el) {
      var num = $(el).data('mm');
      $(".js-megamenu-item-".concat(num)).append($(".js-megamenu-".concat(num)));
    });
  }
};
/* harmony default export */ __webpack_exports__["default"] = (MegaMenu);

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var $ = jQuery.noConflict();
var canBeLoaded = true;
var btn = document.querySelector('.js-load-more');
'use strict';

var LoadPosts = {
  /**
   * @description Cache dom and strings
   * @type {object}
   */

  /** @description Initialize */
  init: function init() {
    this.loadPosts();
  },
  loadPosts: function loadPosts() {
    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var action = '';

        if ($('body.archive').length > 0) {
          action = 'mechdyne_load_posts_tax';
        } else {
          action = 'mechdyne_load_posts';
        } // data object


        var data = {
          action: action,
          page: btn.getAttribute('data-page'),
          paged: btn.getAttribute('data-paged'),
          catId: btn.getAttribute('data-tax') ? btn.getAttribute('data-tax') : '',
          postType: btn.getAttribute('data-post-type')
        };
        LoadPosts.ajaxFunc(data);
      });
    }
  },
  ajaxFunc: function ajaxFunc(data) {
    $.ajax({
      type: 'POST',
      // eslint-disable-next-line no-undef
      url: mechdyne_ajax.ajax_url,
      data: data,
      beforeSend: function beforeSend() {
        // prevent another ajax call before previous is done
        canBeLoaded = false;
      },
      success: function success(response) {
        if (response.content) {
          var scrollpos = jQuery(document).scrollTop(); // append response

          $(response.content).appendTo($('.js-blog-item')); // increment current page

          response.paged++;
          jQuery(document).scrollTop(scrollpos); // if current page is equal to max page remove button for load posts

          if (parseInt(response.paged) === response.max) {
            btn.remove();
          } // flag true


          canBeLoaded = true;
          $('.js-load-more').attr('data-paged', response.paged); // remove loader
        }
      }
    });
  }
};
/* harmony default export */ __webpack_exports__["default"] = (LoadPosts);

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var $ = jQuery.noConflict();
'use strict';

var Accordion = {
  /*-------------------------------------------------------------------------------
  	# Cache dom and strings
  -------------------------------------------------------------------------------*/
  $domAccRow: $('.js-accordion-row:not(.accordion-row--small)'),
  $domAccBottom: $('.js-accordion-bottom'),
  $domAccBtn: $('.js-acc-btn'),
  $classActive: 'active',
  $classRotate: 'rotate',

  /*-------------------------------------------------------------------------------
  	# Initialize
  -------------------------------------------------------------------------------*/
  init: function init() {
    this.toggleFunc(this.$domAccRow);
    this.toggleFuncTitle();
  },
  toggleFunc: function toggleFunc(element) {
    element.on('click', function (e) {
      if ($(this).hasClass(Accordion.$classActive)) {
        Accordion.$domAccRow.removeClass(Accordion.$classActive);
        Accordion.$domAccBtn.removeClass(Accordion.$classRotate);
        Accordion.$domAccBottom.slideUp();
      } else {
        Accordion.$domAccRow.removeClass(Accordion.$classActive);
        Accordion.$domAccBtn.removeClass(Accordion.$classRotate);
        Accordion.$domAccBottom.slideUp();
        $(this).addClass(Accordion.$classActive);
        $(this).find(Accordion.$domAccBottom).slideDown();
        $(this).find(Accordion.$domAccBtn).addClass(Accordion.$classRotate);
      }
    });
  },
  toggleFuncTitle: function toggleFuncTitle() {
    $('.js-acc-btn--small').on('click', function (e) {
      if ($(this).parents('.js-accordion-row').hasClass(Accordion.$classActive)) {
        $(this).parents('.js-accordion-row').removeClass(Accordion.$classActive);
        Accordion.$domAccRow.removeClass(Accordion.$classActive);
        Accordion.$domAccBtn.removeClass(Accordion.$classRotate);
        Accordion.$domAccBottom.slideUp();
      } else {
        Accordion.$domAccBottom.slideUp();
        $(this).parents('.js-accordion-row').addClass(Accordion.$classActive);
        $(this).parents('.js-accordion-row').find(Accordion.$domAccBottom).slideDown();
        $(this).parents('.js-accordion-row').find(Accordion.$domAccBtn).addClass(Accordion.$classRotate);
      }
    });
  }
};
/* harmony default export */ __webpack_exports__["default"] = (Accordion);

/***/ })
/******/ ]);